export enum OrderCopyProductErrorEnum {
  AssortmentUnavailable = 'assortment_unavailable',
}
